import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { Loading } from "src/screens";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import { NetworkConfig } from "src/network/NetworkConfig";

const FileRedirectBase = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fileId = queryParams.get("fileId");

    useEffect(() => {
        if (fileId) {
            const decodedFileId = decodeURIComponent(fileId);
            console.log("Redirecting to file URL:", NetworkConfig.datafileUrl + decodedFileId);
            debugger;
            window.location.href = NetworkConfig.datafileUrl + decodedFileId;
        } else {
            // No file ID provided, redirect to root
            window.location.href = "/";
        }
    }, [fileId]);

    return <Loading />;
};

export const FileRedirect = Sentry.withProfiler(observer(FileRedirectBase));
